import React from 'react';
import { Box, Item, Span, A, Image } from '../../library/react-html-email';

/**
 * EmailProductCard - Email-safe product card component
 * Uses table-based layout for maximum email client compatibility
 * All styles are inline for email rendering
 */
const EmailProductCard = ({ product, assetPath, query = {}, links = [], t }) => {
  const { image, name, description, detailsLink } = product;
  const showDetails = query.details !== 'false';
  const showBuyNow = query.buy !== 'false' && links && links.length > 0;

  // Ensure image URL is absolute or base64
  const hasImage = image && image.trim();
  const imageUrl = hasImage && (image.startsWith('http') || image.startsWith('data:')) ? image : assetPath + image;

  // Make a URL absolute — email clients can't resolve relative paths
  const toAbsolute = (url) => {
    if (!url) return null;
    if (url.startsWith('http')) return url;
    return assetPath + (url.startsWith('/') ? url.slice(1) : url);
  };

  const absoluteDetailsLink = toAbsolute(detailsLink);

  return (
    <Box
      width="100%"
      align="left"
      bgcolor="#ffffff"
      style={{ backgroundColor: '#ffffff' }}
    >
      <Item bgcolor="#ffffff" style={{ backgroundColor: '#ffffff' }}>
        <table cellPadding="0" cellSpacing="0" border="0" width="100%" bgcolor="#ffffff" style={{ backgroundColor: '#ffffff' }}>
          <tr>
            {/* Product Image - 40% (Always maintain width even if no image) */}
            <td bgcolor="#ffffff" style={{ width: '40%', verticalAlign: 'top', padding: '20px', backgroundColor: '#ffffff' }}>
              {hasImage ? (
                <Image
                  src={imageUrl}
                  alt={name}
                  width={200}
                  height={200}
                  style={{
                    width: '200px',
                    height: '200px',
                    objectFit: 'contain',
                    display: 'block'
                  }}
                />
              ) : (
                <table cellPadding="0" cellSpacing="0" border="0">
                  <tr>
                    <td style={{ width: '200px', height: '200px' }}>&nbsp;</td>
                  </tr>
                </table>
              )}
            </td>

            {/* Product Details - 60% */}
            <td bgcolor="#ffffff" style={{ width: '60%', verticalAlign: 'top', padding: '20px 20px 20px 0', backgroundColor: '#ffffff' }}>
              {/* Product Name */}
              <table cellPadding="0" cellSpacing="0" border="0" width="100%">
                <tr>
                  <td style={{ paddingBottom: '12px' }}>
                    <Span
                      fontSize={18}
                      color="#202020"
                      style={{
                        fontWeight: '600',
                        fontFamily: 'Arial, sans-serif',
                        lineHeight: '1.3',
                        display: 'block'
                      }}
                    >
                      {name}
                    </Span>
                  </td>
                </tr>

                {/* Product Description */}
                {description && (
                  <tr>
                    <td style={{ paddingBottom: '16px' }}>
                      <Span
                        fontSize={14}
                        color="#202020"
                        style={{
                          fontFamily: 'Arial, sans-serif',
                          lineHeight: '1.5',
                          display: 'block'
                        }}
                      >
                        {description}
                      </Span>
                    </td>
                  </tr>
                )}

                {/* Product Details Link */}
                {absoluteDetailsLink && showDetails && (
                  <tr>
                    <td style={{ paddingBottom: showBuyNow ? '16px' : '0' }}>
                      <table cellPadding="0" cellSpacing="0" border="0">
                        <tr>
                          <td style={{
                            backgroundColor: '#0C479D',
                            borderRadius: '0px',
                            height: '48px'
                          }}>
                            <A
                              href={absoluteDetailsLink}
                              style={{
                                display: 'inline-block',
                                padding: '12px 32px',
                                backgroundColor: '#0C479D',
                                color: '#ffffff',
                                textDecoration: 'none',
                                fontSize: '18px',
                                fontWeight: '600',
                                fontFamily: 'Arial, sans-serif',
                                lineHeight: '24px',
                                textAlign: 'center',
                                verticalAlign: 'middle'
                              }}
                            >
                              Product details
                            </A>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                )}

                {/* Buy Now Links */}
                {showBuyNow && (
                  <tr>
                    <td>
                      <table cellPadding="0" cellSpacing="0" border="0" width="100%">
                        <tr>
                          <td style={{ paddingBottom: '8px' }}>
                            <Span fontSize={14} color="#202020" style={{ fontWeight: '600', fontFamily: 'Arial, sans-serif' }}>
                              {t('result_page.buy_online')}
                            </Span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <table cellPadding="0" cellSpacing="0" border="0">
                              <tr>
                                {links.map((link, index) => (
                                  <td key={index} style={{ paddingRight: '8px', paddingBottom: '8px' }}>
                                    <A href={toAbsolute(link.url)} style={{ display: 'block', border: '1px solid #ddd', padding: '4px' }}>
                                      <Image
                                        src={toAbsolute(link.img)}
                                        alt={link.supplier}
                                        width={60}
                                        height={30}
                                        style={{ display: 'block', objectFit: 'contain' }}
                                      />
                                    </A>
                                  </td>
                                ))}
                              </tr>
                            </table>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                )}
              </table>
            </td>
          </tr>
        </table>
      </Item>
    </Box>
  );
};

export default EmailProductCard;
